module.exports = __webpack_public_path__ + "media/categories/1026-313e4f2a.svg";